<template>
  <div class="services-second">
    <div class="col-12 services-second-text">
      <h2 class="col-12"><router-link tag="div" :to="{ name: $t('other-services') }">{{ $t("otherServicesTitle") }}</router-link></h2>
      <p class="col-12">{{ $t("otherServicesText") }}</p>
    </div>
    <div class="services-second-cards">
      <div class="services-second-card">
        <div class="service-second-icon text-preview">
          <i :class="`${$t('otherServicesIcon3')}`"></i>
        </div>
        <h3>{{ $t("otherServicesTitle1")}}</h3>
        <div class="services-card-text" id="text-preview">
          <p>{{ $t("otherServicesText1") }}</p>
        </div>
        <router-link class="services-second-card-a" :to="{ name: $t('other-services') }">
          <i class="fa fa-arrow-right"></i>
        </router-link>
      </div>
      <div class="services-second-card">
        <div class="service-second-icon text-preview">
          <i :class="`${$t('otherServicesIcon3')}`"></i>
        </div>
        <h3>{{ $t("otherServicesTitle2")}}</h3>
        <div class="services-card-text" id="text-preview">
          <p>{{ $t("otherServicesText2") }}</p>
        </div>
        <router-link class="services-second-card-a" :to="{ name: $t('other-services') }">
          <i class="fa fa-arrow-right"></i>
        </router-link>
      </div>
      <div class="services-second-card">
        <div class="service-second-icon text-preview">
          <i :class="`${$t('otherServicesIcon3')}`"></i>
        </div>
        <h3>{{ $t("otherServicesTitle3")}}</h3>
        <div class="services-card-text" id="text-preview">
          <p>{{ $t("otherServicesText3") }}</p>
        </div>
        <router-link class="services-second-card-a" :to="{ name: $t('other-services') }">
          <i class="fa fa-arrow-right"></i>
        </router-link>
      </div>
      <div class="services-second-card">
        <div class="service-second-icon text-preview">
          <i :class="`${$t('otherServicesIcon3')}`"></i>
        </div>
        <h3>{{ $t("otherServicesTitle4")}}</h3>
        <div class="services-card-text" id="text-preview">
          <p>{{ $t("otherServicesText4") }}</p>
        </div>
        <router-link class="services-second-card-a" :to="{ name: $t('other-services') }">
          <i class="fa fa-arrow-right"></i>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style scoped>
.services-second {
  background-color: var(--main-color);
  padding: 5% 7%;
}

.services-second-text {
  text-align: center;
  color: white;
  height: 100%;
}

.services-second-text h2 {
  font-size: 30px;
  line-height: 40px;
  color: #fff;
  cursor: pointer;
}

.services-second-text h2 a {
  text-decoration: none;
  color: white;
}

.services-second-text p {
  font-size: 20px;
  margin-top: 2%;
}

.services-second-cards {
  display: flex;
  flex-wrap: wrap;
  margin-top: 2%;
  gap: 15px;
}

.services-second-card {
  display: flex;
  flex-direction: column;
  flex: 1 1 calc(96%/4);
  background: rgb(36, 59, 128);
  background: linear-gradient(180deg, var(--main-color) 20%, rgba(87, 111, 188, 1) 80%);
  color: white;
  padding: 2%;
  box-sizing: border-box;
  min-height: 250px;
  transition: transform 0.2s ease;
}

.services-second-card:hover {
  transform: translateY(-2px);
}

.service-second-icon {
  font-size: 25px;
  line-height: 40px;
}

.service-second-icon i {
  border: 1px solid white;
  border-radius: 50%;
  padding: 3%;
}

.services-second-card h3 {
  font-size: 24px;
  line-height: 40px;
  color: #fff;
  height: 40%;
  text-align: justify;
  margin-top: 5px;
}

.services-second-card p {
  margin: 0;
}

.services-card-text {
  text-align: justify;
  font-size: 18px;
  font-weight: 400;
  height: 40%;
  margin: 15px 0%;
  flex-grow: 1;
}

.services-second-card-a {
  bottom: 10px;
  height: 10%;
  right: 10px;
  color: white;
  font-size: 30px;
  text-decoration: none;
  text-align: right;
}

@media (max-width: 1200px) {
  .services-second-card {
    flex: 1 1 calc(96%/2);
  }
}

@media (max-width: 768px) {
  .services-second-card {
    flex: 1 1 100%;
  }
}
</style>